import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Master_Service_TEAMS_URL } from "../Url";

export const saveTeamsDirectorActions = {
  SAVE_TEAMS_DIRECTOR_DETAILS_SUCCESS: "SAVE_TEAMS_DIRECTOR_DETAILS_SUCCESS",
  SAVE_TEAMS_DIRECTOR_DETAILS_ERROR: "SAVE_TEAMS_DIRECTOR_DETAILS_ERROR",
};

export function saveTeamsDirectorDetailsAll(props) {
  const { access_token, values, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_TEAMS_URL}/savePartnerTeamDetails?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveTeamsDirectorDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveTeamsDirectorDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveTeamsDirectorDetailsError(err));

          return err;
        }
      });
}

export function saveTeamsDirectorDetailsError(error) {
  return {
    type: saveTeamsDirectorActions.SAVE_TEAMS_DIRECTOR_DETAILS_SUCCESS,
    payload: error,
  };
}

export function saveTeamsDirectorDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveTeamsDirectorActions.SAVE_TEAMS_DIRECTOR_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
